import { Observable } from "rxjs";
import { ProcessLine } from ".";

export interface MLCObserverModel {
    mlcObservable: Observable<MLCData>;
    INTBWIObservable: Observable<MLCINTBWarningIndexGroupedData>;
    TBCFWIObservable: Observable<MLCTBCFWarningIndexGroupedData>;
    WarningIndexStatus: Observable<MLCWarningIndexStatusData>;
};
export interface MLCWarningIndexGroupedData {
    [Key: string]: WarningIndexSingleParamData;
};

export interface MLCTBCFWarningIndexGroupedData extends MLCWarningIndexGroupedData { }
export interface MLCINTBWarningIndexGroupedData {
    DCCC1: MLCWarningIndexGroupedData
    DCCC2: MLCWarningIndexGroupedData
};

export interface MLCTrendsGroupedData {
    [Key: string]: TrendsSingleParamData;
};

export interface MLCData {
    MlcType: MLCType;
    Timestamp?: string;
    Line: string | ProcessLine;
    ParameterGroup: string;
    [Key: string]: string | number;
};


export enum MLCType {
    OVERVIEW = "OVERVIEW",
    WARNINGINDEX = "WARNINGINDEX",
    TRENDS = "TRENDS"
};

export enum WarningIndexINTBSolution {
    BC_Application_Deviation = 'BC_Application_Deviation',
    BC_Quantity_Deviation = 'BC_Quantity_Deviation',
};

export interface WarningIndexSingleParamData {
    Average: string;
    Average_Slope: string;
    CriteriaHigh: string;
    CriteriaLow: string;
    Std: string;
    Std_Slope: string;
    Target: string;
    Warning_Index: string | number;
    ParamName: string;
    Timestamp: string;
    MlcType: MLCType.WARNINGINDEX;
    Line: string | ProcessLine;
    getTarget: boolean;
    ParameterGroup: string;
    Acknowledge?: string;
};

export interface TrendsSingleParamData {
    Av1: string;
    Av2: string;
    Timestamp: string;
    MlcType: MLCType.TRENDS;
    Line: string | ProcessLine;
};

export interface MLCOverviewData extends MLCData {
    MlcType: MLCType.OVERVIEW;
};
export interface MLCWarningIndexData extends MLCData {
    MlcType: MLCType.WARNINGINDEX;
};

export interface MLCTrendsData extends MLCData {
    MlcType: MLCType.TRENDS;
};

export type WIProcessFilter = (data?: MLCWarningIndexData) => boolean;
export type MLCDataEntries = [string, string | number][];

export interface WarningIndexMessage {
    Line: string | undefined,
    Warning_Index: number,
    ParamName: string,
    ParsedParamName: string,
    ParameterGroup: string
    Acknowledge?: string | undefined
};

export enum WarningIndexStatuses {
    OK = 'OK',
    WARNING = 'WARNING', // WI <= 50 && WI > 0
    ERROR = 'ERROR' // WI > 50
};

export enum AlarmStatus {
    NO = 'NO',
    YES = "YES"
};
export interface MLCWarningIndexStatusData {
    InTbStatus: WarningIndexStatuses,
    TbCfStatus: WarningIndexStatuses,
    TurnAlarm: AlarmStatus
};

export interface IMLCWarningIndexStatusResponse {
    [key: string]: WarningIndexStatuses
}
